import { useRef } from 'react';
import ReactEcharts from 'echarts-for-react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { useGroupConditionTrend } from '../../modules/organisation/hooks/useGroupStats';
import HomeCard from './HomeCard';
import { getChartLabelColor } from '../lib/utils';
import useElementWidth from '../../hooks/useElementWidth';
import useDeviceStatusFilter from '../../modules/equipment/hooks/useDeviceStatusFilter';

const SM_BREAKDOWN = 510;
const XS_BREAKDOWN = 428;

function ConditionTrend() {
  const { t } = useTranslation();
  const conditionTrend = useGroupConditionTrend();
  const cardRef = useRef(null);
  const width = useElementWidth(cardRef.current);
  const { filterAll } = useDeviceStatusFilter();

  const chartOptions = {
    style: width <= XS_BREAKDOWN ? {
      height: '385px'
    } : {},
    legend: width <= SM_BREAKDOWN ? {
      textStyle: {
        fontSize: 10,
      },
      bottom: -5,
    } : {
      textStyle: {
        fontSize: 12,
      },
      bottom: -5,
    },
    gridBottom: width <= XS_BREAKDOWN ? '30%' : '25%',
  };

  if(!conditionTrend) return null;

  const { items = [], _state_: {loading, error} = {} } = conditionTrend || {};
  const itemsSortedByDate = items.sort((a, b) => {
    return a.date < b.date ? -1 : 1;
  });

  return (
    <div ref={cardRef}>
      <HomeCard
        header={t('home.equipment-condition-trend')}
        headerLink={{ to: '/equipment', text: t('home.all-equipment'), onClick: filterAll }}
        loading={loading}
        error={error}
      >
        <ReactEcharts
          style={chartOptions.style}
          option={{
            tooltip: {
              trigger: 'axis',
            },
            legend: chartOptions.legend,
            xAxis: [{
              data: itemsSortedByDate.map(i => moment(i.date).format('MMM-YY'))
            }],
            yAxis: [{
              type: 'value'
            }],
            grid: {
              top: 10,
              left: 10,
              right: 5,
              bottom: chartOptions.gridBottom,
              containLabel: true,
            },
            color: ['green', 'yellow', 'orange', 'red'].map(color => getChartLabelColor(color)),
            series: [{
              name: t('graph.healthy-equipment'),
              type: 'bar',
              stack: 'one',
              data: itemsSortedByDate.map(i => i.healthy),
            }, {
              name: t('graph.equipment-with-validated-events'),
              type: 'bar',
              stack: 'one',
              data: itemsSortedByDate.map(i => i.with_valid),
            }, {
              name: t('graph.equipment-with-acknowledged-events'),
              type: 'bar',
              stack: 'one',
              data: itemsSortedByDate.map(i => i.with_ack),
            }, {
              name: t('graph.equipment-with-new-events'),
              type: 'bar',
              stack: 'one',
              data: itemsSortedByDate.map(i => i.with_new),
            }]
          }}
        />
      </HomeCard>
    </div>
  );
}

export default ConditionTrend;